'use client';

import { useReferrer } from '@/globals/pageWrappers/usePageHistory';
import { useEffect, useRef } from 'react';

/**
 * Focus transaction block input or button when navigating
 * from a link within the same transaction block.
 *
 * This is a bit of a hack. Because a transaction block
 * can either lead to a new page (SDG) or stay on
 * the same page (SC). We don't know this until
 * the new page has loaded, because SDG pages
 * can fallback to being an SC page.
 */
export const TransactionBlockFocus = ({
	children,
	baseUrl,
}: {
	children: React.ReactNode;
	baseUrl: string;
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const focusDone = useRef(false);
	const referrer = useReferrer();

	useEffect(() => {
		if (focusDone.current) return;
		focusDone.current = true;
		if (referrer?.startsWith(baseUrl)) {
			const target = ref.current?.querySelector('input, button, a');

			if (target instanceof HTMLElement) {
				target.focus();
			}
		}
	}, [referrer, baseUrl]);

	return (
		<div ref={ref} tabIndex={-1}>
			{children}
		</div>
	);
};
